import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

let UiCPartnersComponent = class UiCPartnersComponent {
    constructor() {
        this.edit = new EventEmitter();
        this.delete = new EventEmitter();
        this.onChange = new EventEmitter();
    }
    editBtn() {
        this.edit.emit();
    }
    deleteBtn() {
        this.delete.emit();
    }
};
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCPartnersComponent.prototype, "fullname", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCPartnersComponent.prototype, "docNumber", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCPartnersComponent.prototype, "master", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCPartnersComponent.prototype, "edit", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCPartnersComponent.prototype, "delete", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCPartnersComponent.prototype, "onChange", void 0);
UiCPartnersComponent = __decorate([
    Component({
        selector: 'ui-c-partners',
        template: "<ion-col class=\"details border\">\n    <ion-item lines=\"none\">\n        <ion-col>\n            <ion-text>\n                <p class=\"font-weight-bold\">{{fullname}}</p>\n                <p class=\"font-weight-bold\">{{docNumber}}</p>\n            </ion-text>\n        </ion-col>\n\n        <ion-col class=\"ion-text-right\">\n            <ion-icon class=\"ion-padding-horizontal\" size=\"large\" color=\"primary\" name=\"pencil\"\n                (click)=\"editBtn()\"> </ion-icon>\n            <ion-icon *ngIf=\"master === false || undefined\" class=\"ion-padding-horizontal\"\n                size=\"large\" color=\"danger\" name=\"trash-bin\" (click)=\"deleteBtn()\"> </ion-icon>\n        </ion-col>\n    </ion-item>\n</ion-col>",
        styles: [".ion-text{display:flex;align-items:center;justify-content:center;color:var(--ui-t-color-primary)}.ion-text .ion-icon{font-size:32px}.details{width:268px;margin:0 auto 15px;border-radius:50px;box-shadow:2px 5px 7px 0 #eaeaea}"]
    }),
    __metadata("design:paramtypes", [])
], UiCPartnersComponent);

let UiCPartnersModule = class UiCPartnersModule {
};
UiCPartnersModule = __decorate([
    NgModule({
        declarations: [UiCPartnersComponent],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            IonicModule
        ],
        exports: [
            UiCPartnersComponent
        ],
    })
], UiCPartnersModule);

export { UiCPartnersComponent, UiCPartnersModule };
//# sourceMappingURL=wlp-ui-c-partners.js.map
